/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Surface_Dock_TitleInputs */

const en_surface_dock_title = /** @type {(inputs: Surface_Dock_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`minimized · ${i?.count}`)
};

const ar_surface_dock_title = /** @type {(inputs: Surface_Dock_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`مصغّرة · ${i?.count}`)
};

const bn_surface_dock_title = /** @type {(inputs: Surface_Dock_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ছোট করা · ${i?.count}`)
};

const de_surface_dock_title = /** @type {(inputs: Surface_Dock_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`minimiert · ${i?.count}`)
};

const es_surface_dock_title = /** @type {(inputs: Surface_Dock_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`minimizadas · ${i?.count}`)
};

const fr_surface_dock_title = /** @type {(inputs: Surface_Dock_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`réduites · ${i?.count}`)
};

const pt_surface_dock_title = /** @type {(inputs: Surface_Dock_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`minimizadas · ${i?.count}`)
};

const zh_surface_dock_title = /** @type {(inputs: Surface_Dock_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已最小化 · ${i?.count}`)
};

const tr_surface_dock_title = /** @type {(inputs: Surface_Dock_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`küçültüldü · ${i?.count}`)
};

const ru_surface_dock_title = /** @type {(inputs: Surface_Dock_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`свёрнуто · ${i?.count}`)
};

const pl_surface_dock_title = /** @type {(inputs: Surface_Dock_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`zminimalizowane · ${i?.count}`)
};

/**
* | output |
* | --- |
* | "minimized · {count}" |
*
* @param {Surface_Dock_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const surface_dock_title = /** @type {((inputs: Surface_Dock_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Surface_Dock_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_surface_dock_title(inputs)
	if (locale === "bn") return bn_surface_dock_title(inputs)
	if (locale === "de") return de_surface_dock_title(inputs)
	if (locale === "es") return es_surface_dock_title(inputs)
	if (locale === "fr") return fr_surface_dock_title(inputs)
	if (locale === "pt") return pt_surface_dock_title(inputs)
	if (locale === "zh") return zh_surface_dock_title(inputs)
	if (locale === "tr") return tr_surface_dock_title(inputs)
	if (locale === "ru") return ru_surface_dock_title(inputs)
	if (locale === "pl") return pl_surface_dock_title(inputs)
	return en_surface_dock_title(inputs)
});